import script from "./ChangeLanguage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeLanguage.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeLanguage.vue?vue&type=style&index=0&id=2dffba4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dffba4a"]])

export default __exports__